export default __webpack_public_path__ + "static/media/Image 97.b0342237.png";